import src from "IMAGE";
export default { src, width: 810, height: 514, blurWidth: 0, blurHeight: 0};
